import { useCallback } from "react";
import type { Department } from "../../../api";
import { store } from "../../../store";
import { useFetchAction, type UseFetchActionReturn } from "../utils";

export const useFetchDepartment = (
    departmentId?: string | null,
): UseFetchActionReturn<Department | undefined> => {
    const fetchDepartment: () => Promise<Department | undefined> = useCallback(() => {
        if (departmentId) {
            return store.departmentsApi.departmentsReadDepartment({ departmentId });
        } else {
            return Promise.resolve(undefined);
        }
    }, [departmentId]);
    return useFetchAction(fetchDepartment);
};
